
import ko from 'knockout';
import * as mapping from 'knockout-mapping';
import Filters from '../filters';

let json = $("#page-data").text();
let data = mapping.fromJSON(json);

let catJson = $("#category-data").text();
var catData = null;

if (catJson != '')
    catData = JSON.parse(catJson);

let sortByJson = $("#sortby-data").text();
let sortByData = mapping.fromJSON(sortByJson);

let dom = document.getElementById('products-browse');

data.sortBy = function() {
    var x = sortByData();
    return x;
};

Filters.init(data, sortByData);
ko.applyBindings(data, dom);


$(".sortByText").html(Filters.SortByToFriendly(sortByData()));

$(function()  {
    if (catData != null) {
        (window as any).klaviyo.track("Viewed Category", {
            "CategoryName": catData?.Name,
            "CategoryID": catData?.Id,
            "Slug": catData?.Slug
        }).then(function (e) {
            console.log('tracked category');
        });
    }
})